class InstagramFeed {
	constructor() {
		this.selectors = {
			document: document,
		};
		this.init();
		this.timeout_1 = null;
		this.timeout_2 = null;
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {
		var token = $('.insta_token').text(), // ваш токен
		    n = 0, number = 8;
	    if($('.insta_token').length > 0){
			$.ajax({
	            url: 'https://graph.instagram.com/me',
			    dataType: 'jsonp',
			    type: 'GET',
			    data: {access_token: token, fields: "media_count,media"},
			    success: function(data){
			        $.each(data.media.data, (key,item) =>{
						$.ajax({
					        url: 'https://graph.instagram.com/' + item.id,
					        dataType: 'jsonp',
					        type: 'GET',
					        data: {access_token: token, fields: "media_url,media_type"},
					        success: function(data2){
					            if(data2.media_type == "IMAGE" && n < number){
			                        $('#insta_feed').append('<li class="insta_feed_item"><img src="'+data2.media_url+'"></li>');
			                        n++;
				                }
				            },
					        error: function(data2){
					            console.log(data2);
					        }
					    });
				    })
			    },
			    error: function(data){
			        console.log(data);
			    }
			});
		}

	}
}
new InstagramFeed();